import type { PublicationContentTag } from '~/interfaces/publication';

const ARCHIVE_PATH = '/archive';

export const resolveCollectionHubHref = (tags: string[], contentTags?: PublicationContentTag[]): string => {
  if (tags.length !== 1) return ARCHIVE_PATH;

  const [tag] = tags;
  const match = contentTags?.find(({ display }) => display.toLowerCase() === tag.toLowerCase());

  return `/t/${match?.slug || encodeURIComponent(tag)}`;
};
